import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

/**
 * FencingSwordsIcon - Due spade da scherma (fioretti) incrociate
 */
export const FencingSwordsIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        {/* Spada 1 (da basso-sinistra a alto-destra) */}
        <path
            d="M3 21L19 5"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
        <circle cx="5" cy="19" r="2" fill="none" stroke="currentColor" strokeWidth="1.2" />
        <path d="M19 5L21 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />

        {/* Spada 2 (da basso-destra a alto-sinistra) */}
        <path
            d="M21 21L5 5"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
        <circle cx="19" cy="19" r="2" fill="none" stroke="currentColor" strokeWidth="1.2" />
        <path d="M5 5L3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
);

/**
 * FencingMaskIcon - Maschera da scherma con reticolo
 */
export const FencingMaskIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <ellipse
            cx="12"
            cy="12"
            rx="7"
            ry="10"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
        />
        {/* Reticolo interno */}
        <path d="M8 7L16 7M7 10L17 10M6 13L18 13M7 16L17 16M9 19L15 19" stroke="currentColor" strokeWidth="1" opacity="0.6" />
        <path d="M10 5L10 19M12 4L12 20M14 5L14 19" stroke="currentColor" strokeWidth="1" opacity="0.6" />
    </SvgIcon>
);

/**
 * HomeIcon - Icona casa
 */
export const HomeIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M12 3L4 9v12h5v-7h6v7h5V9l-8-6z" fill="currentColor" />
    </SvgIcon>
);

/**
 * SettingsIcon - Icona ingranaggio
 */
export const CustomSettingsIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" fill="currentColor" />
    </SvgIcon>
);

/**
 * ChartBarIcon - Icona istogramma (per Girone)
 */
export const ChartBarIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8h2.8v6h-2.8z" fill="currentColor" />
    </SvgIcon>
);

/**
 * TrophyIcon - Icona trofeo (per Eliminazione)
 */
export const TrophyIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M18 2H6v2H2v6c0 2.21 1.79 4 4 4h2c.41 1.63 1.52 3.06 3 3.72V20H7v2h10v-2h-4v-2.28c1.48-.66 2.59-2.09 3-3.72h2c2.21 0 4-1.79 4-4V4h-4V2zM4 10V6h2v4c0 1.1-.9 2-2 2s-2-.9-2-2zm16 0c0 1.1-.9 2-2 2s-2-.9-2-2V6h2v4z" fill="currentColor" />
    </SvgIcon>
);

/**
 * MedalIcon - Icona medaglia (per Classifica)
 */
export const MedalIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm0-8c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM7.07 18.28c.43.24.81.56 1.14.92L12 22l3.79-2.8c.33-.36.71-.68 1.14-.92.83-.46 1.14-1.5 1.14-1.5V11s-.31-1.04-1.14-1.5c-.88-.48-2.07-.5-2.07-.5L12 2 9.14 9s-1.19.02-2.07.5C6.23 9.96 5.92 11 5.92 11v5.78s.32 1.04 1.15 1.5z" fill="currentColor" />
    </SvgIcon>
);

/**
 * UsersIcon - Icona gruppo (per SQUADRE)
 */
export const UsersIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="currentColor" />
    </SvgIcon>
);

/**
 * UserIcon - Icona persona (per INDIVIDUALE)
 */
export const UserIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor" />
    </SvgIcon>
);

/**
 * PirateIcon - Icona teschio e spade (per MISTE)
 */
export const PirateIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M12 2C9.24 2 7 4.24 7 7c0 1.91 1.08 3.56 2.67 4.39L10 14h4l.33-2.61C15.92 10.56 17 8.91 17 7c0-2.76-2.24-5-5-5zM9 7c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3z" fill="currentColor" />
        <path d="M21 21l-3-3 1.41-1.41L21 18.17l1.59-1.58L24 18l-3 3zM3 21l3-3-1.41-1.41L3 18.17 1.41 16.59 0 18l3 3z" fill="currentColor" />
        <path d="M12 16h-1l-1 5 1 1h2l1-1-1-5h-1z" fill="currentColor" />
    </SvgIcon>
);

/**
 * BookIcon - Icona libro (per GUIDA)
 */
export const BookIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z" fill="currentColor" />
    </SvgIcon>
);

/**
 * WarningIcon - Icona triangolo con punto esclamativo
 */
export const WarningIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="currentColor" />
    </SvgIcon>
);

/**
 * InfoIcon - Icona cerchio con "i"
 */
export const InfoIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="currentColor" />
    </SvgIcon>
);

/**
 * TargetIcon - Icona bersaglio
 */
export const TargetIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" fill="currentColor" />
    </SvgIcon>
);

/**
 * TrendingUpIcon - Icona freccia in salita (Crescita/Ranking)
 */
export const TrendingUpIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" fill="currentColor" />
    </SvgIcon>
);

/**
 * SmartphoneIcon - Icona smartphone
 */
export const SmartphoneIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z" fill="currentColor" />
    </SvgIcon>
);

/**
 * LightbulbIcon - Icona lampadina (Idee/Suggerimenti)
 */
export const LightbulbIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C8.25 12.45 7 10.82 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.82-1.25 3.45-3.15 4.1z" fill="currentColor" />
    </SvgIcon>
);

/**
 * VideoIcon - Icona videocamera
 */
export const VideoIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" fill="currentColor" />
    </SvgIcon>
);

/**
 * EditIcon - Icona matita
 */
export const EditIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor" />
    </SvgIcon>
);

/**
 * TimerIcon - Icona timer
 */
export const TimerIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" fill="currentColor" />
    </SvgIcon>
);

/**
 * SwapIcon - Icona doppia freccia orizzontale
 */
export const SwapIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" fill="currentColor" />
    </SvgIcon>
);

/**
 * RefreshIcon - Icona freccia circolare
 */
export const RefreshIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" fill="currentColor" />
    </SvgIcon>
);

/**
 * FencingCardIcon - Icona rettangolare (per cartellini)
 */
export const FencingCardIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <rect x="5" y="3" width="14" height="18" rx="2" fill="currentColor" />
    </SvgIcon>
);

/**
 * TagIcon - Icona etichetta
 */
export const TagIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 8.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z" fill="currentColor" />
    </SvgIcon>
);

/**
 * DeleteIcon - Icona cestino
 */
export const DeleteIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor" />
    </SvgIcon>
);

/**
 * ArrowUpIcon - Freccia su
 */
export const ArrowUpIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" fill="currentColor" />
    </SvgIcon>
);

/**
 * ArrowDownIcon - Freccia giù
 */
export const ArrowDownIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" fill="currentColor" />
    </SvgIcon>
);

/**
 * DragHandleIcon - Icona tre linee orizzontali (Drag and Drop)
 */
export const DragHandleIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" fill="currentColor" />
    </SvgIcon>
);

/**
 * ScheduleIcon - Icona calendario/lista (per Assalti)
 */
export const ScheduleIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" fill="currentColor" />
    </SvgIcon>
);




